module.exports = __webpack_public_path__ + "static/crizelle-anne-32f4c507442162716ff2664be157dfd5.png";